/** ACT004 用户信息表单热点：绑定字段（与控台 act004-user-form-fields.js 对齐） */
export const ACT004_USER_FORM_FIELD_OPTIONS = [
  { value: 'phone', label: '手机号' },
  { value: 'real_name', label: '姓名' },
  { value: 'nickname', label: '昵称' },
  { value: 'avatar', label: '头像' },
  { value: 'birthday', label: '生日' },
  { value: 'card_id', label: '身份证' },
  { value: 'company_name', label: '公司名称' },
  { value: 'employee_no', label: '员工号' },
  { value: 'channel', label: '渠道' }
]

export const ACT004_USER_FORM_FIELD_BINDS = ACT004_USER_FORM_FIELD_OPTIONS.map((o) => o.value)

export function normalizeAct004UserFormFieldBind(bind, fallback = 'phone') {
  const b = String(bind || fallback).trim().toLowerCase()
  return ACT004_USER_FORM_FIELD_BINDS.includes(b) ? b : fallback
}

export function act004UserFormFieldLabel(field) {
  const f = String(field || '').trim().toLowerCase()
  if (f === 'name') return '姓名'
  const hit = ACT004_USER_FORM_FIELD_OPTIONS.find((o) => o.value === f)
  return hit ? hit.label : field || ''
}

export function act004UserFormDraftKey(hotspot) {
  const idx = hotspot && hotspot.index != null && hotspot.index !== '' ? String(hotspot.index) : ''
  const bind = hotspot && hotspot.userFieldBind != null ? String(hotspot.userFieldBind).trim() : ''
  if (bind) return `${idx}:${bind}`
  return idx ? `idx:${idx}` : ''
}

/** type=26 单选组按绑定字段读写草稿（同组多热点共享） */
export function act004UserFormFieldBindDraftKey(bind) {
  const b = String(bind || '').trim().toLowerCase()
  return b ? `field:${b}` : ''
}

export function readUserFormDraftByHotspot(draft, hotspot) {
  const d = draft && typeof draft === 'object' ? draft : {}
  const primary = act004UserFormDraftKey(hotspot)
  if (primary && d[primary] != null && String(d[primary]) !== '') {
    return String(d[primary])
  }
  const idx = hotspot && hotspot.index != null ? String(hotspot.index) : ''
  const legacy = idx ? `${idx}:` : ''
  if (legacy && d[legacy] != null) return String(d[legacy])
  const legacyIdx = idx ? `idx:${idx}` : ''
  if (legacyIdx && d[legacyIdx] != null) return String(d[legacyIdx])
  return ''
}

export function readUserFormFieldDraftByBind(draft, bind) {
  const d = draft && typeof draft === 'object' ? draft : {}
  const key = act004UserFormFieldBindDraftKey(bind)
  if (key && d[key] != null && String(d[key]) !== '') {
    return String(d[key])
  }
  return ''
}

export function act004InputTypeForField(field) {
  const f = String(field || '').trim().toLowerCase()
  if (f === 'phone') return 'tel'
  if (f === 'birthday') return 'date'
  return 'text'
}

/** 将草稿字段规范化为 form_lead 可识别的 key */
export function normalizeAct004FormLeadFields(fields) {
  const src = fields && typeof fields === 'object' ? fields : {}
  const out = {}
  Object.keys(src).forEach((k) => {
    const key = String(k || '').trim().toLowerCase()
    if (!key) return
    out[key] = src[k] == null ? '' : String(src[k]).trim()
  })
  return out
}

export const ACT004_CONDITIONAL_JUMP_CONDITION_TYPES = [
  { value: 'PROFILE_FIELDS', label: '完善字段' },
  { value: 'CHECKIN_POINTS', label: '打卡点位' }
]

const PROFILE_FIELD_BINDS = ACT004_USER_FORM_FIELD_BINDS.slice()

export function normalizeConditionalTargetConditionType(type) {
  const t = String(type || '').trim().toUpperCase()
  return t === 'CHECKIN_POINTS' ? 'CHECKIN_POINTS' : 'PROFILE_FIELDS'
}

export function normalizeConditionalTargetCheckinIndexes(indexes) {
  const arr = Array.isArray(indexes) ? indexes : []
  const out = []
  arr.forEach((raw) => {
    const n = parseInt(raw, 10)
    if (!Number.isFinite(n) || n <= 0 || out.includes(n)) return
    out.push(n)
  })
  return out
}

export function normalizeConditionalTargetFields(fields) {
  const allowed = {}
  PROFILE_FIELD_BINDS.forEach((f) => {
    allowed[f] = true
  })
  const arr = Array.isArray(fields) ? fields : []
  const out = []
  arr.forEach((raw) => {
    const f = String(raw || '').trim().toLowerCase()
    if (!allowed[f] || out.includes(f)) return
    out.push(f)
  })
  return out
}

export function isAct004ProfileFieldsComplete(getFieldValue, fields) {
  const required = normalizeConditionalTargetFields(fields)
  if (!required.length) return false
  const getVal = typeof getFieldValue === 'function' ? getFieldValue : () => ''
  return required.every((f) => String(getVal(f) || '').trim() !== '')
}

export function evaluateConditionalJumpTarget(options) {
  const opts = options && typeof options === 'object' ? options : {}
  const type = normalizeConditionalTargetConditionType(opts.conditionType)
  if (type === 'CHECKIN_POINTS') {
    const indexes = normalizeConditionalTargetCheckinIndexes(opts.checkinIndexes)
    if (!indexes.length || typeof opts.isCheckinPointDone !== 'function') {
      return false
    }
    return indexes.every((idx) => !!opts.isCheckinPointDone(idx))
  }
  return isAct004ProfileFieldsComplete(opts.getProfileFieldValue, opts.profileFields)
}

export function normalizeConditionalTargetRule(rule) {
  if (!rule || typeof rule !== 'object') return null
  const targetPageIndex = parseInt(rule.targetPageIndex, 10)
  if (!Number.isFinite(targetPageIndex) || targetPageIndex < 0) return null
  const conditionType = normalizeConditionalTargetConditionType(rule.conditionType)
  const profileFields = normalizeConditionalTargetFields(rule.profileFields || rule.fields)
  const checkinIndexes = normalizeConditionalTargetCheckinIndexes(rule.checkinIndexes)
  if (conditionType === 'PROFILE_FIELDS' && !profileFields.length) return null
  if (conditionType === 'CHECKIN_POINTS' && !checkinIndexes.length) return null
  return {
    conditionType,
    profileFields,
    checkinIndexes,
    targetPageIndex
  }
}

export function normalizeConditionalTargetRules(source) {
  if (Array.isArray(source)) {
    return source.map((r) => normalizeConditionalTargetRule(r)).filter(Boolean)
  }
  if (!source || typeof source !== 'object') return []
  if (Array.isArray(source.conditionalTargetRules)) {
    return normalizeConditionalTargetRules(source.conditionalTargetRules)
  }
  const legacyPage = parseInt(source.conditionalTargetPageIndex, 10)
  if (!Number.isFinite(legacyPage) || legacyPage < 0) return []
  const legacy = normalizeConditionalTargetRule({
    conditionType: source.conditionalTargetConditionType,
    profileFields: source.conditionalTargetFields,
    checkinIndexes: source.conditionalTargetCheckinIndexes,
    targetPageIndex: legacyPage
  })
  return legacy ? [legacy] : []
}

export function hotspotNeedsProfileFieldsConditionalVerify(rulesSource) {
  const rules = normalizeConditionalTargetRules(rulesSource)
  return rules.some(
    (r) =>
      r.conditionType === 'PROFILE_FIELDS' &&
      Array.isArray(r.profileFields) &&
      r.profileFields.length > 0
  )
}

export function resolveConditionalTargetPageIndex(rulesSource, evaluateOptions, defaultPageIndex) {
  const parsedDefault = parseInt(defaultPageIndex, 10)
  const fallback =
    defaultPageIndex != null &&
    defaultPageIndex !== '' &&
    Number.isFinite(parsedDefault) &&
    parsedDefault >= 0
      ? parsedDefault
      : null
  const rules = normalizeConditionalTargetRules(rulesSource)
  const opts = evaluateOptions && typeof evaluateOptions === 'object' ? evaluateOptions : {}
  for (let i = 0; i < rules.length; i++) {
    const r = rules[i]
    if (
      evaluateConditionalJumpTarget({
        conditionType: r.conditionType,
        profileFields: r.profileFields,
        checkinIndexes: r.checkinIndexes,
        getProfileFieldValue: opts.getProfileFieldValue,
        isCheckinPointDone: opts.isCheckinPointDone
      })
    ) {
      return r.targetPageIndex
    }
  }
  return fallback
}
